/* LiquorVerse shipping-coverage panel — open/close only.

   Intentionally minimal [Ethan 2026-07-28]: this states where we ship, it does
   not verify an address. Real verification (address + tax) happens at checkout
   through the retailer's 3JMS integration, and unserviceable orders are
   cancelled and refunded there. A live checker is a future custom app; the
   earlier address-lookup flow is documented in docs §AB if it's revived. */
(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-lv-ship-check]');
    if (!root) return;

    function open() {
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = root.querySelector('[data-lv-sc-close]');
      if (close) setTimeout(function () { close.focus(); }, 40);
    }
    function close() {
      root.hidden = true;
      document.body.style.overflow = '';
    }

    /* Delegated so any trigger works, including markup rendered later. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-lv-ship-check-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-lv-sc-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
